/**
 * @author 3173
 * @desc 系列化关联课程表单页面
 * @date 2020-09-23
 */
import React from "react";
import {connect} from "dva";
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {WizTableForm, WizAuthority, WizClassifySelectRe} from '../../../common'
let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool
let {WizCard, WizSpin, WizForm, Wizmessage} = component_tool
let {Session} = utils_tool



class SeriesContentDetail extends WizContainer {
  componentName = 'seriesContentDetail'

  constructor(props) {
    super(props)
    const {history} = props
    let initialValue = {}
    let cardTitle = '新增'

    if (history.location && history.location.pathname === '/series/seriesList/seriesContentList/seriesContentDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('seriesContentDetail', initialValue)
      } else {
        initialValue = Session.get('seriesContentDetail') || {}
      }
      cardTitle = '编辑'
      if(initialValue.programId && initialValue.programName){
        initialValue.programInfo = [{id:initialValue.programId,name:initialValue.programName}]
      }
      if(initialValue.categoryName && initialValue.categoryIds){

         let categoryNames = initialValue.categoryName.split(",");
         if(categoryNames.length == initialValue.categoryIds.length){
           let categoryInfo = [];
           for(let i=0;i<categoryNames.length;i++){
             let info = {};
             info.id = initialValue.categoryIds[i];
             info.title = categoryNames[i];
             info.key = initialValue.categoryIds[i];
             categoryInfo.push(info);
           }
           initialValue.categoryInfo = categoryInfo;
         }
      }

    }else if(history.location && history.location.pathname === '/series/seriesList/seriesContentList/seriesContentDetailAdd'){
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('seriesContentDetail', initialValue)
      } else {
        initialValue = Session.get('seriesContentDetail') || {}
      }
    }

    this.initialValue = initialValue
    this.state = {
      cardTitle,
      time:"defKey"
    }
  }

  _componentDidMount() {
    // if (this.initialValue.categoryId) {
    //   this.doAction({
    //     path: 'questionType/normalNodeList',
    //     payload: {
    //       key: 'type8TreeData',
    //       apiParams: {
    //         id: this.initialValue.categoryId,
    //         type: 8
    //       }
    //     }
    //   })
    // }
  }

  propsAndStateOnChange = {
    saveSeriesProgram: this._saveSeriesOver.bind(this)
  }


  _saveSeriesOver(nextProps, nextState) {
    if (nextProps.saveSeriesProgram.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/series/seriesList/seriesContentList',);
    } else {
      wizNotice.error('提交失败：' + nextProps.saveSeriesProgram.msg);
    }
    return true;
  }

  _sumbit(values) {
    const {history} = this.props
    let apiPath = 'seriesProgram/add';
    if (history.location && history.location.pathname === '/series/seriesList/seriesContentList/seriesContentDetailUpd') {
      apiPath = 'seriesProgram/update'
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveSeriesProgram',
        apiParams: {...values,id:this.initialValue.id,seriesId:this.initialValue.seriesId}
      }
    })
  }

  _render() {
    const {seriesProgramLoading} = this.props
    const {cardTitle} = this.state
    let initialValue = this.initialValue

    const entityConfig = WizTableForm.Config.program(this, {apiParams: {status: 1}});
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.id
        }
      },
      {
        title: '课程',
        name: 'programId',
        formItem: {
          ...entityConfig,
          diy: WizTableForm,
          initialValue: initialValue.programId,
          initRows: initialValue.programInfo ? initialValue.programInfo : [],
          selectType:'radio',
          rules: [ {
            required: true,
            message: '请选择课程'
          } ],
        }
      },
      {
        title: '分类',
        name: 'categoryIds',
        formItem: {
          type: 'diy',
          diy: WizClassifySelectRe,
          returnKey: true,
          wizTreeSelectListProps: {
            itemProps: {
              icon: 'unordered-list',
              title: '课程分类',
              tips: '请勾选所属课程分类'
            },
            treeProps: { checkStrictly: true }
          },
          apiProps: { type: 8,id:initialValue.categoryId },
          selectProps: {
            placeholder: '请选择课程分类'
          },
          rules: [
            {
              type: 'array'
            }
          ],
          initialValue: initialValue.categoryIds ? initialValue.categoryIds : [],
          initSelects: initialValue.categoryInfo ? initialValue.categoryInfo :[],
        }
      },

      {
        title: '状态',
        name: 'state',
        formItem: {
          initialValue: initialValue.state != null ? initialValue.state : 1,
          type: 'radio'
        },
        dict: [
          {code: 1, codeName: '有效'},
          {code: 0, codeName: '无效'}
        ]
      },
    ]

    let onSubmit = this._sumbit.bind(this)

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={seriesProgramLoading}>
          <WizForm key={this.state.time} className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {seriesProgram} = state;
  const saveSeriesProgram = modelUtils.getModelEntity(seriesProgram, 'saveSeriesProgram');
  const load = modelUtils.getLoadingState(state, 'seriesProgram');
  return {
    saveSeriesProgram,
    ...load
  }
}

export default connect(mapStateToProps)(SeriesContentDetail);

